import { request } from "./http";

const toIsoDate = (yyyyMmDd) => {
  if (!yyyyMmDd) return null;
  const d = new Date(`${yyyyMmDd}T00:00:00`);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
};

export const productsService = {
  listPublic() {
    return request("/Products", { auth: false });
  },

  listAdmin() {
    return request("/Products/admin");
  },

  // ✅ POST /api/Products/assign
  assign(payload) {
    return request("/Products/assign", {
      method: "POST",
      body: payload,
    });
  },

  assignFromUi({ companyId, productId, hasPaid, hasAccess, startDate, endDate }) {
    const access = !!hasAccess;

    const payload = {
      companyId,
      productId: Number(productId),
      hasPaid: !!hasPaid,
      hasAccess: access,
      licenseStartDate: access ? toIsoDate(startDate) : null,
      licenseEndDate: access ? toIsoDate(endDate) : null,
    };

    return request("/Products/assign", {
      method: "POST",
      body: payload,
    });
  },
};
